import React, { FC } from 'react';

import ModalScreen from 'components/Modals/ModalScreen';
import useConnect from './connect';
import {
  Container,
  Actions,
  StatusButton,
  ButtonsBlock,
  ActionButton,
  LoadersWrapper,
} from './styles';
import ExtraInfo from './ExtraInfo';
import Summary from './Summary';
import ExtraInfoLoader from './ExtraInfo/Loader';
import SummaryLoader from './Summary/Loader';

const Orders: FC = () => {
  const {
    handleClose,
    order,
    isLoading,
    handleMarkReady,
    handleMarkComplete,
    isChangeStatusLoading,
    handlePrintOrder,
  } = useConnect();

  if (!order && !isLoading) {
    return <>{handleClose()}</>;
  }

  if (!order && isLoading) {
    return (
      <>
        <ModalScreen open title="Order Detail" handleClose={handleClose}>
          <Container>
            <LoadersWrapper>
              <SummaryLoader opacity={1} />
              <SummaryLoader opacity={0.5} />
            </LoadersWrapper>
            <ExtraInfoLoader />
          </Container>
        </ModalScreen>
      </>
    );
  }

  return (
    <ModalScreen open title="Order Detail" handleClose={handleClose}>
      <Container>
        {order && (
          <>
            <Summary order={order} />
            <ExtraInfo order={order} />
          </>
        )}
      </Container>
      <Actions>
        <ButtonsBlock>
          {order?.status.key === 'PENDING' && (
            <>
              <StatusButton variant="pending" active />
              <StatusButton
                variant="ready"
                active={false}
                onClick={handleMarkReady}
                disabled={isChangeStatusLoading}
              />
              <StatusButton
                variant="complete"
                active={false}
                onClick={handleMarkComplete}
                disabled={isChangeStatusLoading}
              />
            </>
          )}
          {order?.status.key === 'READY' && (
            <>
              <StatusButton variant="pending" active={false} disabled />
              <StatusButton variant="ready" active />
              <StatusButton
                variant="complete"
                active={false}
                onClick={handleMarkComplete}
                disabled={isChangeStatusLoading}
              />
            </>
          )}
          {order?.status.key === 'COMPLETE' && (
            <>
              <StatusButton variant="pending" active={false} disabled />
              <StatusButton variant="ready" active={false} disabled />
              <StatusButton variant="complete" active />
            </>
          )}
          {order?.status.key === 'SCHEDULED' && (
            <StatusButton variant="scheduled" active />
          )}
          {order?.status.key === 'CANCELLED' && (
            <StatusButton variant="cancelled" active />
          )}
          {order && <ActionButton variant="print" onClick={handlePrintOrder} />}
        </ButtonsBlock>
      </Actions>
    </ModalScreen>
  );
};

export default Orders;
